import { fetchFlags } from '../fetch-flags';
import { getFlag, isFlagEnabled } from '../evaluate/is-flag-enabled';
import type {
  FeatureFlag,
  FeatureFlagsConfig,
  FeatureFlagsContextValues,
  FeatureFlagsResponse,
  HttpAdapter,
} from '../types/feature-flags.types';

/**
 * @deprecated Stateful wrapper kept for `@portal-front/feature-flags/angular`, which is slated
 * for deletion — delete this file with it. Everything else uses `fetchFlags` and `isFlagEnabled`
 * directly.
 *
 * Holds no logic of its own: it stores the last loaded flag list and delegates. New code should
 * not add behaviour here.
 */
export class FeatureFlagsCore {
  private featureFlags: FeatureFlagsResponse;

  constructor(
    private httpAdapter: HttpAdapter,
    private config: FeatureFlagsConfig,
  ) {
    this.featureFlags = { ...config.defaultFlags };
  }

  async loadFeatureFlags(): Promise<FeatureFlagsResponse> {
    this.featureFlags = await fetchFlags(this.config, (url) => this.httpAdapter.get(url));

    return this.featureFlags;
  }

  isFeatureEnabled(flagName: string, context?: FeatureFlagsContextValues): boolean {
    return isFlagEnabled(this.featureFlags, flagName, { cookies: this.config.cookies, context });
  }

  getFeatureFlag(flagName: string): FeatureFlag | undefined {
    return getFlag(this.featureFlags, flagName);
  }

  getFeatureFlags(): FeatureFlagsResponse {
    return { ...this.featureFlags };
  }
}
